<template>
  <v-card width="100%" class="ma-6">
    <v-card-title>
      Komentari
    </v-card-title>

    <v-card-text>
      <v-row v-if="loading">
        <v-col cols="12" class="text-center">
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </v-col>
      </v-row>

      <v-row v-else-if="loading == false && comments.length === 0">
        <v-col cols="12">
          <v-alert
            type="info"
            outlined
          >
            Nema komentara.
          </v-alert>
        </v-col>
      </v-row>

      <v-list v-else select-strategy="leaf">
        <template v-for="comment in comments">
          <v-list-item
            :key="comment.id"
            :value="comment.id"
            active-class="text-pink"
            class="py-3"
          >
            <v-row width="100%" align="start">
              <v-col cols="12" md="3">
                <div class="font-weight-medium">
                  {{ getCommentProperty(comment, "fullName") }}
                </div>

                <div class="text-caption text-medium-emphasis mt-1">
                  {{ getCommentProperty(comment, "createdAt") }}
                </div>
              </v-col>

              <v-col cols="12" sm="3">
                <div class="mb-1">
                  <v-icon small class="mr-1">
                    mdi-email
                  </v-icon>

                  {{ getCommentProperty(comment, "email") }}
                </div>
              </v-col>

              <v-col cols="12" sm="3">
                <div>
                  <v-icon small class="mr-1">
                    mdi-phone
                  </v-icon>

                  {{ getCommentProperty(comment, "phone") }}
                </div>
              </v-col>

              <v-col
                cols="12"
                sm="2"
                class="d-flex justify-end align-center"
              >
                <v-btn
                  icon
                  small
                  @click="openEditDialog(comment)"
                >
                  <v-icon color="primary">
                    mdi-pencil
                  </v-icon>
                </v-btn>

                <v-btn
                  icon
                  small
                  @click="openDeleteDialog(comment)"
                >
                  <v-icon color="red">
                    mdi-delete
                  </v-icon>
                </v-btn>
              </v-col>

              <v-col cols="12">
                <div class="mt-2">
                  {{ getCommentProperty(comment, "content") }}
                </div>
              </v-col>
            </v-row>
          </v-list-item>

          <v-divider
            :key="'divider-' + comment.id"
            inset
          ></v-divider>
        </template>
      </v-list>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn
        color="primary"
        outlined
        @click="showAddCommentDialog = true"
      >
        <v-icon left>
          mdi-plus
        </v-icon>

        Dodaj komentar
      </v-btn>
    </v-card-actions>

    <!-- ADD COMMENT DIALOG -->

    <v-dialog
      v-model="showAddCommentDialog"
      max-width="700"
    >
      <v-card>
        <v-card-title>
          Dodavanje komentara
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="newComment.content"
                label="Sadržaj komentara"
                outlined
                rows="4"
              ></v-textarea>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="newComment.email"
                label="Email"
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="newComment.phone"
                label="Telefon"
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="newComment.userContacted"
                :items="[true, false]"
                label="Korisnik kontaktiran"
                outlined
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            text
            @click="closeAddCommentDialog"
          >
            Otkaži
          </v-btn>

          <v-btn
            color="primary"
            @click="addComment"
          >
            Dodaj
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- EDIT COMMENT DIALOG -->

    <v-dialog
      v-model="showEditCommentDialog"
      max-width="700"
    >
      <v-card>
        <v-card-title>
          Izmena komentara
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-textarea
                v-model="editComment.content"
                label="Sadržaj komentara"
                outlined
                rows="4"
              ></v-textarea>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editComment.email"
                label="Email"
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editComment.phone"
                label="Telefon"
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="editComment.userContacted"
                :items="[true, false]"
                label="Korisnik kontaktiran"
                outlined
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            text
            @click="showEditCommentDialog = false"
          >
            Otkaži
          </v-btn>

          <v-btn
            color="primary"
            @click="updateComment"
          >
            Sačuvaj
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DELETE COMMENT DIALOG -->

    <v-dialog
      v-model="showDeleteCommentDialog"
      max-width="500"
    >
      <v-card>
        <v-card-title>
          Brisanje komentara
        </v-card-title>

        <v-card-text>
          Da li ste sigurni da želite da obrišete komentar?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            text
            @click="showDeleteCommentDialog = false"
          >
            Otkaži
          </v-btn>

          <v-btn
            color="red"
            @click="deleteComment"
          >
            Obriši
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import * as utils from '../utils.js';
import * as apiComments from '../api/comments.js';

export default {
  name: 'CommentsList',
  props: {
    companyId: {
      type: Number,
      required: false
    },
    tempCompanyId: {
      type: Number,
      required: false
    },
  },
  data: function () {
    return {
      loading: false,
      comments: [],

      showAddCommentDialog: false,
      showEditCommentDialog: false,
      showDeleteCommentDialog: false,

      selectedComment: null,

      newComment: {
        content: '',
        userContacted: null,
        email: '',
        phone: '',
        tempCompId: null,
        compId: null
      },

      editComment: {
        id: null,
        content: '',
        userContacted: null,
        email: '',
        phone: '',
        tempCompId: null,
        compId: null
      }
    }
  },
  methods: {
    getCommentProperty(comment, propertyName) {
      if (propertyName === 'fullName') {
        return `${comment.userCreated.firstName} ${comment.userCreated.lastName}`;
      }

      if (propertyName === 'username') {
        return comment.userCreated.username;
      }

      if (propertyName === 'createdAt') {
        return utils.formatDate(comment.createdAt);
      }

      return comment[propertyName];
    },

    getCommentsFromApi() {
      this.loading = true;

      if (this.companyId) {
        apiComments.getCommentsForCompany(
          this.companyId,
          this.$store.getters.token
        )
          .then(response => response.json())
          .then(responseData => {
            this.comments = responseData;
          })
          .catch(() => {
            console.log("Greška! Komentari nisu preuzeti.");
            this.comments = [];
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (this.tempCompanyId) {
        apiComments.getCommentsForTempCompany(
          this.tempCompanyId,
          this.$store.getters.token
        )
          .then(response => response.json())
          .then(responseData => {
            this.comments = responseData;
          })
          .catch(() => {
            console.log("Greška! Komentari nisu preuzeti.");
            this.comments = [];
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    closeAddCommentDialog() {
      this.showAddCommentDialog = false;

      this.newComment = {
        content: '',
        userContacted: null,
        email: '',
        phone: '',
        tempCompId: null,
        compId: null
      };
    },

    addComment() {
      this.newComment.compId = this.companyId;
      this.newComment.tempCompId = this.tempCompanyId;

      apiComments.addComment(
        this.newComment,
        this.$store.getters.token
      )
        .then(() => {
          this.closeAddCommentDialog();
          this.getCommentsFromApi();
        })
        .catch(() => {
          console.log("Greška! Komentar nije dodat.");
        });
    },

    openEditDialog(comment) {
      this.selectedComment = comment;

      this.editComment = {
        id: comment.id,
        content: comment.content,
        userContacted: comment.userContacted,
        email: comment.email,
        phone: comment.phone,
        tempCompId: comment.tempCompId,
        compId: comment.compId
      };

      this.showEditCommentDialog = true;
    },

    openDeleteDialog(comment) {
      this.selectedComment = comment;
      this.showDeleteCommentDialog = true;
    },

    updateComment() {
      apiComments.updateComment(
        this.editComment.id,
        this.editComment,
        this.$store.getters.token
      )
        .then(() => {
          this.showEditCommentDialog = false;
          this.getCommentsFromApi();
        })
        .catch(() => {
          console.log("Greška! Komentar nije izmenjen.");
        });
    },

    deleteComment() {
      apiComments.deleteComment(
        this.selectedComment.id,
        this.$store.getters.token
      )
        .then(() => {
          this.showDeleteCommentDialog = false;
          this.getCommentsFromApi();
        })
        .catch(() => {
          console.log("Greška! Komentar nije obrisan.");
        });
    }
  },

  mounted() {
    this.getCommentsFromApi();
  }
}
</script>
